const getExclusionsUrl = companyId => `/api/companies/${companyId}/taskTypes/exclusions`;

export class TaskTypeExclusionApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getTypes({ companyId }) {
    return this.#http.get(getExclusionsUrl(companyId));
  }

  async createType({ companyId, taskTypeId }) {
    return this.#http.post(`${getExclusionsUrl(companyId)}/${taskTypeId}`);
  }

  async deleteType({ companyId, taskTypeId }) {
    return this.#http.delete(`${getExclusionsUrl(companyId)}/${taskTypeId}`);
  }
}
